import React, { useEffect, useState, useCallback } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../shared/components/SmallLoader';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import {
    getSalesByRegionData, handleLoader, getTopSalesProductData, getTopSalesLocationsData,
    handleTopProductLoader, handleTopLocationLoader
} from '../../../redux/actions/SalesByRegionAction';
import { setCurrencyFormat, findMonthsBetweenDates } from '../../../utils/helpers';
import { months } from '../helper';
import RegionHeatMap from './RegionHeatMap';
import TopLocation from './TopLocation';
import TopProduct from './TopProduct';

const SalesByRegion = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const [currentYear, currentMonth] = moment().format('YYYY-MMM').split('-');
    const [prevYear, prevMonth] = moment().subtract(1, 'months').format('YYYY-MMM').split('-');

    const { salesByRegionHeatmapData, salesChannelFilterData, isLoading, topCategorySalesData, topLocationSalesData
        , isTopProductLoading, isTopLocationsLoading } = useSelector(
            ({ salesByRegionReducer, marketPlaceReducer }) =>
            ({
                salesByRegionHeatmapData: salesByRegionReducer.salesByRegionHeatmapData,
                salesChannelFilterData: marketPlaceReducer.salesChannel,
                isLoading: salesByRegionReducer.isLoading,
                topLocationSalesData: salesByRegionReducer.topLocationSalesData,
                topCategorySalesData: salesByRegionReducer.topCategorySalesData,
                isTopLocationsLoading: salesByRegionReducer.isTopLocationsLoading,
                isTopProductLoading: salesByRegionReducer.isTopProductLoading
            })
        );

    const [regions, setRegions] = useState([]);
    const [subregions, setSubRegions] = useState([]);
    const [productCategories, setProductCategories] = useState([]);

    const [dataToShowHeatMap, setDataToShowHeatMap] = useState([]);
    const [dataToShowTopProduct, setDataToShowTopProduct] = useState([]);
    const [dataToShowTopLoc, setDataToShowTopLoc] = useState([]);

    const [filterData, setFilterData] = useState({});

    const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth });
    const [month1, setMonth1] = useState({ year: prevYear, month: prevMonth })
    const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
    const [tempMonth1, setTempMonth1] = useState({ year: prevYear, month: prevMonth })
    const [region, setRegion] = useState(null);
    const [subregion, setSubRegion] = useState(null);
    const [productCategory, setProductCategory] = useState(null);
    const [type, setType] = useState(null);

    const yearOptions = [];
    for (let year = 2016; year <= currentYear; year += 1) {
        yearOptions.push({ label: year, value: year })
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Sales By Region Report ${new Date().getFullYear()}`,
    })   
  }

    const regionOptions = () => {
        const options = [];
        regions?.filterData?.forEach((regionItem) => {
            if (regionItem.longValue) {
                options.push({ value: regionItem.longValue, label: regionItem.key })
            }
        })

        return options
    }

    const subregionOptions = () => {

        const options = []
        subregions?.filterData?.filter(item => item.parentLinkObject === region?.value)?.forEach((regionItem) => {
            if (regionItem.longValue) {
                options.push({ value: regionItem.longValue, label: regionItem.key })
            }
        })

        return options
    }

    const productCategoriesOptions = () => {
        const options = [];
        productCategories?.filterData?.forEach((productCategoryItem) => {
            if (productCategoryItem.longValue && productCategoryItem.longValue !== 'productCategory' 
            && productCategoryItem.longValue !== 'productCategory ') {
                options.push({ value: productCategoryItem.longValue, label: productCategoryItem.key })
            }
        })        
        return options
    }

    const monthOptions = months.map(item => ({ label: item, value: item }));

    const filterBasedOnFilter = (item, isProdCatFilter) => {
        
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
            if ((region && item.region !== region?.value) || (subregion && item.subRegion !== subregion?.value)) {
                flag = false;
            }
            if(isProdCatFilter){
                if((productCategory && item.prodCategory !== productCategory?.value)) {
                    flag = false;
                }
            }
        }
        return flag
    }

    const callApi = ({ tempMon1, tempMon2 }) => {
        const data = {
            from: tempMon1?.year, to: tempMon2?.year,
            fromMonth: moment(tempMon1?.month, 'MMM').format('M'),
            toMonth: moment(tempMon2?.month, 'MMM').format('M'),

        }

        dispatch(handleLoader(true));
        dispatch(getSalesByRegionData(data));

        dispatch(handleTopProductLoader(true))
        dispatch(getTopSalesProductData({
            ...data,
            isCityWise: !!type?.value, region: region?.value, subRegion: subregion?.value,
            prodCategory: productCategory?.value
        }));

        dispatch(handleTopLocationLoader(true))
        dispatch(getTopSalesLocationsData({
            ...data,
            isCityWise: !!type?.value, region: region?.value, subRegion: subregion?.value,
            prodCategory: productCategory?.value
        }));
    }

    const handleApplyDate = () => {
        const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
        const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

        const monthsBetween = findMonthsBetweenDates(startDate, endDate);
        if (monthsBetween?.length > 0 && monthsBetween?.length <= 12) {
            setMonth1(tempMonth1);
            setMonth2(tempMonth2);
            callApi({ tempMon1: tempMonth1, tempMon2: tempMonth2 });
        } else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'Please select maximum one year data'
                });
            });
        }
    }

    const handleYearMonthChange = ({ isFrom, field, value }) => {

        if (isFrom) {
            setTempMonth1({ ...tempMonth1, [field]: value?.value });
        } else {
            setTempMonth2({ ...tempMonth2, [field]: value?.value });
        }
    }

    // eslint-disable-next-line react/prop-types
    const RenderYearAndMonth = ({ isFrom }) => (
        <Col sm="3" className="pl-0">
            <Row className="">
                <Col sm="5" className="p-0">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">{isFrom ? 'Previous' : 'Current'} Year</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                                    : { value: tempMonth2?.year, label: tempMonth2?.year }}
                                options={yearOptions}
                                clearable={false}
                                placeholder="Select Year"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'from' : 'to'}
                            />
                        </div>

                    </div>
                </Col>
                <Col sm="5" className="pr-0">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Month</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                                    : { value: tempMonth2?.month, label: tempMonth2?.month }}
                                options={monthOptions}
                                clearable={false}
                                placeholder="Select Month"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'fromMonth' : 'toMonth'}
                            />
                        </div>
                    </div>
                </Col>
            </Row>

        </Col>
    );

    useEffect(() => {
        dispatch(handleLoader(true));
        dispatch(getSalesByRegionData({
            from: tempMonth1?.year, to: tempMonth2?.year,
            fromMonth: moment(tempMonth1?.month, 'MMM').format('M'),
            toMonth: moment(tempMonth2?.month, 'MMM').format('M'), isCityWise: false
        }));
        callApi({ tempMon1: tempMonth1, tempMon2: tempMonth2 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setDataToShowHeatMap(salesByRegionHeatmapData?.modal?.data);
        setProductCategories(salesByRegionHeatmapData?.modal
            ?.filters?.[0] || []);
        setRegions(salesByRegionHeatmapData?.modal
            ?.filters?.[1] || []);
        setSubRegions(salesByRegionHeatmapData?.modal
            ?.filters?.[2] || []);
    }, [salesByRegionHeatmapData]);

    useEffect(() => {
        setDataToShowTopProduct(topCategorySalesData?.modal?.data?.[0]?.yearlyRegionSalesDTO);
        setDataToShowTopLoc(topLocationSalesData?.modal?.data?.[0]?.yearlyRegionSalesDTO);
    }, [topCategorySalesData, topLocationSalesData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    const dataToShowHeatMapForDatesSelected = dataToShowHeatMap?.filter(item =>
        filterBasedOnFilter(item, false));

    const dataToShowTopProductForDatesSelected = dataToShowTopProduct?.filter(item =>        
        filterBasedOnFilter(item, true));

    const dataToShowTopLocForDatesSelected = dataToShowTopLoc?.filter(item =>
        filterBasedOnFilter(item, true));

    return (    
        <Container className="dashboard">
            <Row className="sales-breakdown">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">Sales By Region </h5>
                            </div>
                            <Row className="justify-content-center align-items-center">
                                <Col sm="2" className="pr-0">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Region</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={region}
                                                options={regionOptions()}
                                                isClearable
                                                placeholder="Select "
                                                className="select_filter"
                                                onChange={value => setRegion(value)}
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                    </div>
                                </Col>
                                <Col sm="2" className="pr-0">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Sub Region</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                isClearable
                                                value={subregion}
                                                options={subregionOptions()}
                                                placeholder="Select "
                                                className="select_filter"
                                                onChange={value => setSubRegion(value)}
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                    </div>
                                </Col>
                                <Col sm="2" className="pr-0">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Type</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={type}
                                                options={[{ value: 1, label: 'City' },
                                                { value: 0, label: 'State' }]}
                                                placeholder="Select "
                                                className="select_filter"
                                                onChange={value => setType(value)}
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                    </div>
                                </Col>

                                <RenderYearAndMonth isFrom />
                                <RenderYearAndMonth />
                                                               
                            </Row>
                            <Row className="justify-content-left align-items-left">
                                <Col sm="4" className="pr-0">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">Product Category</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={productCategory}
                                                options={productCategoriesOptions()}
                                                isClearable
                                                placeholder="Select "
                                                className="select_filter-326"
                                                onChange={value => setProductCategory(value)}
                                                classNamePrefix="react-select"
                                            />
                                        </div>

                                    </div>
                                </Col>
                                <Col sm="3" className="p-0">
                                    <button className="btn btn-sm btn-primary apply-date-button"
                                        type="button" style={{marginLeft: 15}} onClick={handleApplyDate}>
                                        Apply</button>
                                        <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                                </Col> 
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Row className="show-sales-region">
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <div className="top-location" style={{ minHeight: '400' }}>
                                <div className="card__title row align-items-center">
                                    <h5 className="bold-text col">Sales By Country  </h5>
                                </div>
                                <div >
                                    {isLoading ? <div style={{ minHeight: '200px' }}
                                        className="row align-items-center justify-content-center">
                                        <SmallLoader loading={isLoading} />
                                    </div>
                                        : <RegionHeatMap mapData={dataToShowHeatMapForDatesSelected} />}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>


                <Col md="12">
                    <Card>
                        <CardBody>
                            <div className="top-location" style={{ minHeight: '400' }}>
                                <div className="card__title row align-items-center">
                                    <h5 className="bold-text col-md-4">Top 15 Locations</h5>
                                </div>
                                <div >
                                    {isTopLocationsLoading ? <div style={{ minHeight: '200px' }}
                                        className="row align-items-center justify-content-center">
                                        <SmallLoader loading={isTopLocationsLoading} />
                                    </div>
                                        : <TopLocation
                                            height={400} data={dataToShowTopLocForDatesSelected} type={type} />}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <div className="top-location">
                                <div className="card__title row align-items-center">
                                    <h5 className="bold-text col-md-4">Top 15 Products</h5>
                                </div>
                                <div >
                                    {isTopProductLoading ? <div style={{ minHeight: '200px' }}
                                        className="row align-items-center justify-content-center">
                                        <SmallLoader loading={isTopProductLoading} />
                                    </div>
                                        : <TopProduct
                                            height={400} data={dataToShowTopProductForDatesSelected} />}
                                </div>
                            </div>
                        </CardBody>

                    </Card>
                </Col>
            </Row >
            </div>

        </Container >
    );
};

SalesByRegion.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
};

export default connect(state => ({
    rtl: state.rtl,
}))(SalesByRegion);
